import Invocation from '../api/Invocation';
import UserStore from '../stores/UserStore';

var DomainActions = {
    getDomains: function () {
        var clientId = UserStore.getClientId();

        if (clientId) {
            Invocation.domain.getDomains(clientId);
        }
    }
};
module.exports = DomainActions;



// WEBPACK FOOTER //
// ./app/actions/DomainActions.js